import { metaRepo } from '../../data/repositories';
import { useComposerStore } from './useComposer';

/**
 * The sentence carried across the one reload the person can ask for (`SHL-09`, ADR-042).
 *
 * The composer is deliberately **not** persisted — `uiStore` is described as the one store that may be
 * lost on relaunch, because reopening on Sprechen with an empty buffer is always the right behaviour. This
 * is not a change of mind about that. It is a handover: written only when the repair control's last step
 * reloads the page, and cleared the moment it has been read.
 *
 * Without it, the last resort eats a sentence that may have taken a minute to type, at the moment its
 * author is already not being heard — which would make it a button we should be embarrassed to offer.
 *
 * Cleared *before* the text reaches the composer, so a write that fails cannot leave a draft that
 * reappears on every launch afterwards: a stale sentence in front of somebody who has moved on is worse
 * than the one loss this is preventing.
 */
export async function restoreDraft(): Promise<void> {
  try {
    const meta = await metaRepo.get();
    const draft = meta.draft;
    if (draft === undefined || draft === '') return;

    await metaRepo.update({ draft: '' });
    useComposerStore.getState().insert(draft);
  } catch (err) {
    // A draft that cannot be restored is a lost sentence, which is bad. A boot that fails because of it
    // would be no voice at all, which is worse.
    console.error('[draft] could not be restored', err);
  }
}
